import { Adjustment } from './adjustment';
import { SubOption } from './suboption';
import { OptionIncludeExclude } from './option-include-exclude';
import { DeselectedOption } from './deselected-option';

export class SelectedOption {
    public SelectedOptionId: number;
    public QuoteId: number;
    public Price: number;
    public Quantity: number;
    public Note: string;
    public UnitPrice: number;
    public AdjustedUnitPrice: string;       // **** NOT USED ****
    public TotalPrice: number;
    public AdjustedTotalPrice: number;
    public IsCustomOption: boolean;
    public OptionDesc: string;
    public OptionNumber: string;
    public HomeOptionsOptionId: number;
    public HomeOptionsCategoryId: number;
    public HomeOptionsSubOptionId: number;
    public IsValidUnitPrice: boolean;
    public IsCustomPrice: boolean;
    public CategoryName: string;
    public HasIncludeExcludeOptions: boolean;
    public ModifiedBy: string;
    public UIUnitPrice: string;
    public UnitPriceOverride: number;
    public StandardPrice: number;
    public Visible: boolean;
    public FrequencySequenceNumber: number;
    public StandardOption: boolean;
    public StandardQuantity: number;

    // this variable is used to highlight the option description on the quote summary page
    public WasChanged: boolean;
    public ChangedByFacility: boolean;
    // this variable is used to determine if a change was made to the UI
    public WasUIChanged: boolean;

    // added for performance refactor
    public OptionId: number;
    public OptionDescription: string;
    public SelectedSubOptionDesc: string;
    public SelectedSubOptionId: number = -1;
    public IsIncluded: boolean;
    public IsExcluded: boolean;
    public IncludePrice: boolean;
    public InvalidSubOption: boolean;
    public HomeOptionsCategoryDescription: string;
    public SubOptionCount: number;
    public IncludeExcludeCount: number;
    public MaxQuantity: number;
    public SelectedOptionSubOptions: SubOption[];
    public IncludeExclude: OptionIncludeExclude[];
    public SelectedOptionDeselectOptions: DeselectedOption[];
    public AdminOptionsExist: boolean;
    public QuoteRevisionNumber: number;

    constructor() {
        this.UnitPriceOverride = null;
        this.UIUnitPrice = '0.00';
        this.SelectedOptionSubOptions = new Array<SubOption>();
        this.IncludeExclude = new Array<OptionIncludeExclude>();
        this.SelectedOptionDeselectOptions = new Array<DeselectedOption>();
        this.InvalidSubOption = false;
        this.WasUIChanged = false;
        this.AdminOptionsExist = false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/selected-option.ts